import { useState, useEffect } from 'react'
import { CONNECTION } from 'configs/configs.js'
import { IObject } from 'interfaces'
import { useAuth, useFetch } from 'hooks'
import { UploadFile } from 'components/index'
import { clearString } from 'helper/utils'

interface IProps {
  document: string
  documentList: any[]
  pf?: boolean
  readonly?: boolean
  onChange?: any
  isOnForm?: boolean
  onClickRemoveFile?: any
}

export default function (props: IProps) {
  const [identification, setIdentification] = useState<any>()
  const [identificationb, setIdentificationb] = useState<any>()
  const [residence, setResidence] = useState<any>()
  const [contratoSocial, setContratoSocial] = useState<any>()
  const [acordoSocios, setAcordoSocios] = useState<any>()
  const [fichaCNPJ, setFichaCNPJ] = useState<any>()
  const {
    document,
    documentList,
    pf,
    readonly,
    isOnForm,
    onChange,
    onClickRemoveFile,
  } = props

  const api = useFetch()
  const { token } = useAuth()

  function sendDocument(formdata: FormData) {
    api
      .fetch('put', formdata, `/gestor/requirements/${clearString(document)}`, {
        'Content-type': 'multipart/form-data',
      })
      .then(console.log)
  }

  useEffect(() => {
    const documents = pf
      ? [
          ['identification', setIdentification],
          ['identificationb', setIdentificationb],
          ['residence', setResidence],
        ]
      : [
          ['identification', setIdentification],
          ['identificationb', setIdentificationb],
          ['fichaCNPJ', setFichaCNPJ],
          ['socialContract', setContratoSocial],
          ['acordoSocios', setAcordoSocios],
        ]

    documents.forEach((doc: any[]) => {
      const [type, fn] = doc
      const item = documentList.find((i: IObject) => i.type === type)
      item &&
        fn({
          url: `${CONNECTION.URL}/app/protected/${item.file}?token=${token}`,
          name: item.file,
        })
    })
  }, [documentList])

  return (
    <div className="status-card-container-cards">
      {pf ? (
        <div style={{ width: '100%' }}>
          <h4>Upload de documentos</h4>
          <div className="documents-container">
            <UploadFile
              disableInput={readonly}
              download
              // visualize={!isOnForm}
              visualize
              url={
                identification?.url ||
                (identification && URL.createObjectURL(identification))
              }
              fileName="RG ou CNH frente"
              file={identification}
              mandatory
              onChangeFile={(_n, e: File) => {
                if (isOnForm && onChange) {
                  setIdentification(e)
                  return onChange('documentList', e, 'identification')
                }
                onChange && onChange('documentList', e, 'identification')
                const formData = new FormData()
                formData.append('documentList', e, 'identification')
                sendDocument(formData)
              }}
              onClickRemoveFile={() => {
                onClickRemoveFile && onClickRemoveFile('identification')
                setIdentification(undefined)
              }}
              options={{
                icon: 'file.svg',
                accept: 'application/pdf,image/*',
                label: identification?.name
                  ? identification?.name
                  : 'Upload Arquivo',
                info: '• Documento formato PDF',
              }}
            />
            <UploadFile
              disableInput={readonly}
              download
              // visualize={!isOnForm}
              visualize
              url={
                identificationb?.url ||
                (identificationb && URL.createObjectURL(identificationb))
              }
              fileName="RG ou CNH verso"
              file={identificationb}
              mandatory
              onChangeFile={(_n, e: File) => {
                if (isOnForm && onChange) {
                  setIdentificationb(e)
                  return onChange('documentList', e, 'identificationb')
                }
                onChange && onChange('documentList', e, 'identificationb')
                const formData = new FormData()
                formData.append('documentList', e, 'identificationb')
                sendDocument(formData)
              }}
              onClickRemoveFile={() => {
                onClickRemoveFile && onClickRemoveFile('identificationb')
                setIdentificationb(undefined)
              }}
              options={{
                icon: 'file.svg',
                accept: 'application/pdf,image/*',
                label: identificationb?.name
                  ? identificationb?.name
                  : 'Upload Arquivo',
                info: '• Documento formato PDF',
              }}
            />
            <UploadFile
              disableInput={readonly}
              download
              // visualize={!isOnForm}
              visualize
              url={
                residence?.url || (residence && URL.createObjectURL(residence))
              }
              ready
              fileName="Comp. de residência"
              file={residence}
              onChangeFile={(_n, e: File) => {
                if (isOnForm && onChange) {
                  setResidence(e)
                  return onChange('documentList', e, 'residence')
                }
                onChange && onChange('documentList', e, 'residence')
                const formData = new FormData()
                formData.append('documentList', e, 'residence')
                sendDocument(formData)
              }}
              onClickRemoveFile={() => {
                onClickRemoveFile && onClickRemoveFile('residence')
                setResidence(undefined)
              }}
              options={{
                icon: 'file.svg',
                accept: 'application/pdf,image/*',
                label: 'Upload de arquivo',
                info: '• Documento formato PDF',
              }}
            />
          </div>
        </div>
      ) : (
        <>
          <h4>Upload de documentos</h4>
          <div className="documents-container">
            <UploadFile
              disableInput={readonly}
              download
              mandatory
              // visualize={!isOnForm}
              visualize
              url={
                fichaCNPJ?.url || (fichaCNPJ && URL.createObjectURL(fichaCNPJ))
              }
              fileName="Ficha CNPJ"
              file={fichaCNPJ}
              ready
              onChangeFile={(_n, e: File) => {
                if (isOnForm && onChange) {
                  setFichaCNPJ(e)
                  return onChange('documentList', e, 'fichaCNPJ')
                }
                onChange && onChange('documentList', e, 'fichaCNPJ')
                const formData = new FormData()
                formData.append('documentList', e, 'fichaCNPJ')
                sendDocument(formData)
              }}
              onClickRemoveFile={() => {
                onClickRemoveFile && onClickRemoveFile('fichaCNPJ')
                setFichaCNPJ(undefined)
              }}
              options={{
                icon: 'file.svg',
                accept: 'application/pdf,image/*',
                label: identification?.name
                  ? identification?.name
                  : 'Upload Arquivo',
                info: '• Documento formato PDF',
              }}
            />
            <UploadFile
              download
              disableInput={readonly}
              // visualize={!isOnForm}
              visualize
              url={
                contratoSocial?.url ||
                (contratoSocial && URL.createObjectURL(contratoSocial))
              }
              ready
              fileName="Contrato social"
              file={contratoSocial}
              onChangeFile={(_n, e: File) => {
                if (isOnForm && onChange) {
                  setContratoSocial(e)
                  return onChange('documentList', e, 'socialContract')
                }
                onChange && onChange('documentList', e, 'socialContract')
                const formData = new FormData()
                formData.append('documentList', e, 'socialContract')
                sendDocument(formData)
              }}
              onClickRemoveFile={() => {
                onClickRemoveFile && onClickRemoveFile('socialContract')
                setContratoSocial(undefined)
              }}
              options={{
                icon: 'file.svg',
                accept: 'application/pdf,image/*',
                label: 'Upload Arquivo',
                info: '• Documento formato PDF',
              }}
            />
            <UploadFile
              download
              // visualize={!isOnForm}
              visualize
              url={
                acordoSocios?.url ||
                (acordoSocios && URL.createObjectURL(acordoSocios))
              }
              disableInput={readonly}
              ready
              fileName="Acordo de sócios"
              file={acordoSocios}
              onChangeFile={(_n, e: File) => {
                if (isOnForm && onChange) {
                  setAcordoSocios(e)
                  return onChange('documentList', e, 'acordoSocios')
                }
                onChange && onChange('documentList', e, 'acordoSocios')
                const formData = new FormData()
                formData.append('documentList', e, 'acordoSocios')
                sendDocument(formData)
              }}
              onClickRemoveFile={() => {
                onClickRemoveFile && onClickRemoveFile('acordoSocios')
                setAcordoSocios(undefined)
              }}
              options={{
                icon: 'file.svg',
                accept: 'application/pdf,image/*',
                label: 'Upload Arquivo',
                info: '• Documento formato PDF',
              }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <h4>Documento do sócio administrador</h4>
            <div className="documents-container">
              <UploadFile
                download
                mandatory
                disableInput={readonly}
                // visualize={!isOnForm}
                url={
                  identification?.url ||
                  (identification && URL.createObjectURL(identification))
                }
                fileName="RG ou CNH"
                file={identification}
                ready
                onChangeFile={(_n, e: File) => {
                  if (isOnForm && onChange) {
                    setIdentification(e)
                    return onChange('documentList', e, 'identification')
                  }
                  onChange && onChange('documentList', e, 'identification')
                  const formData = new FormData()
                  formData.append('documentList', e, 'identification')
                  sendDocument(formData)
                }}
                onClickRemoveFile={() => {
                  onClickRemoveFile && onClickRemoveFile('identification')
                  setIdentification(undefined)
                }}
                options={{
                  icon: 'file.svg',
                  accept: 'application/pdf,image/*',
                  label: identification?.name
                    ? identification?.name
                    : 'Upload Arquivo',
                  info: '• Documento formato PDF',
                }}
              />
              <UploadFile
                disableInput={readonly}
                download
                // visualize={!isOnForm}
                visualize
                url={
                  identificationb?.url ||
                  (identificationb && URL.createObjectURL(identificationb))
                }
                fileName="RG ou CNH verso"
                file={identificationb}
                mandatory
                onChangeFile={(_n, e: File) => {
                  if (isOnForm && onChange) {
                    setIdentificationb(e)
                    return onChange('documentList', e, 'identificationb')
                  }
                  onChange && onChange('documentList', e, 'identificationb')
                  const formData = new FormData()
                  formData.append('documentList', e, 'identificationb')
                  sendDocument(formData)
                }}
                onClickRemoveFile={() => {
                  onClickRemoveFile && onClickRemoveFile('identificationb')
                  setIdentificationb(undefined)
                }}
                options={{
                  icon: 'file.svg',
                  accept: 'application/pdf,image/*',
                  label: identificationb?.name
                    ? identificationb?.name
                    : 'Upload Arquivo',
                  info: '• Documento formato PDF',
                }}
              />
            </div>
          </div>
        </>
      )}
    </div>
  )
}
